<div class="flex h-7">
    <input type="checkbox" [id]="id" [(ngModel)]="defaultValue" (click)="callbackToggle(!defaultValue, id)"/><label [for]="id"></label>
</div>
